module.exports = __webpack_public_path__ + "assets/img/social/twitter-icon.963e935806c807fb70696d6c2137f869.svg";